import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../hooks/useLanguage';
import { resetPassword } from '../services/authApi';

const ResetPassword = () => {
  const { token } = useParams();
  const { t } = useTranslation();
  const { getLocalizedPath } = useLanguage();
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    if (password.length < 6) {
      setError(
        t('auth.reset.minLength') || 'Password must be at least 6 characters'
      );
      return;
    }
    if (password !== confirm) {
      setError(t('auth.reset.mismatch') || 'Passwords do not match');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await resetPassword(token, password);
      navigate(getLocalizedPath('/account'));
    } catch (err) {
      setError(err?.message || 'Failed to reset password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mt-[78px]">
      <div className="max-w-[1280px] mx-auto pt-8 sm:pt-[92px] pb-[166px] sm:pb-[100px] break-words whitespace-normal">
        <div className="px-5 text-center">
          <h2 className="text-black text-[32px] leading-[40px] sm:text-[40px] sm:leading-[50px] tracking-[-1.25px] font-normal uppercase libre-baskerville mb-4 sm:mb-5">
            {t('auth.reset.title') || 'Reset Password'}
          </h2>
          <p className="text-[#727272] text-[16px] leading-[20px] tracking-[-1px] font-normal">
            {t('auth.reset.subtitle') || 'Enter your new password'}
          </p>
        </div>
        <form
          onSubmit={onSubmit}
          className="mt-10 max-w-[600px] mx-auto bg-[#F6F6F6] px-5 sm:px-[50px] py-6 sm:py-[33px] space-y-6"
        >
          <div className="w-full space-y-3">
            <label className="text-[#000000] text-[14px] font-normal leading-[15px] uppercase">
              {t('auth.register.passwordLabel') || 'Password'}
            </label>
            <input
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              className="bg-[#0000001A] w-full px-6 py-3.5 text-[12px] leading-[19px] tracking-[-0.64px] outline-none"
            />
          </div>
          <div className="w-full space-y-3">
            <label className="text-[#000000] text-[14px] font-normal leading-[15px] uppercase">
              {t('auth.reset.confirmLabel') || 'Confirm Password'}
            </label>
            <input
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              type="password"
              className="bg-[#0000001A] w-full px-6 py-3.5 text-[12px] leading-[19px] tracking-[-0.64px] outline-none"
            />
          </div>
          {error ? (
            <div className="text-red-600 text-center text-sm">{error}</div>
          ) : null}
          <button
            disabled={loading}
            type="submit"
            className="bg-[#000000] w-full py-5 text-white text-[13px] leading-[14px] uppercase font-medium"
          >
            {loading
              ? t('auth.reset.submitting') || '...'
              : t('auth.reset.submit') || 'Reset Password'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
